// Verificar lançamentos vencidos
export const checkVencimentos = (lancamentos) => {
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  
  const vencidos = lancamentos.filter(item => {
    if (item.status !== 'PENDENTE') return false;
    if (!item.data_vencimento) return false;
    
    const dataVenc = new Date(item.data_vencimento);
    dataVenc.setHours(0, 0, 0, 0);
    
    return dataVenc < hoje;
  });
  
  const vencemHoje = lancamentos.filter(item => {
    if (item.status !== 'PENDENTE') return false;
    if (!item.data_vencimento) return false;
    
    const dataVenc = new Date(item.data_vencimento);
    dataVenc.setHours(0, 0, 0, 0);
    
    return dataVenc.getTime() === hoje.getTime();
  });
  
  return { vencidos, vencemHoje };
};

// Enviar notificação (simulada)
export const sendNotification = (titulo, mensagem, tipo = 'info') => {
  // No navegador, usar Notification API
  if ('Notification' in window && Notification.permission === 'granted') {
    new Notification(titulo, { body: mensagem, icon: '📊' });
  }
  
  // Também mostrar no console
  console.log(`[${tipo.toUpperCase()}] ${titulo}: ${mensagem}`);
};

// Adicionar ao Dashboard
export const showVencimentoAlert = (vencidos, vencemHoje) => {
  let mensagem = '';
  let alerta = false;
  
  if (vencemHoje.length > 0) {
    mensagem += `⚠️ ${vencemHoje.length} lançamento(s) vencem HOJE!\n`;
    alerta = true;
  }
  
  if (vencidos.length > 0) {
    mensagem += `❌ ${vencidos.length} lançamento(s) estão VENCIDOS!\n`;
    alerta = true;
  }
  
  if (alerta) {
    sendNotification('🔔 Alertas de Vencimento', mensagem, 'warning');
    return mensagem;
  }
  
  return null;
};